import { AbilityBuilder } from "@casl/ability";
import pako from "pako";
import { ManageApplication as ManageApplicationV2 } from "../config/v2/application";
import { ManageContact as ManageContactV2 } from "../config/v2/contact";
import { ManageSetting as ManageSettingV2 } from "../config/v2/setting";
import { ManageVat as ManageVatV2 } from "../config/v2/vat";
import { ManageWhtCertificateAndPnd as ManageWhtCertificateAndPndV2 } from "../config/v2/wht";

function UserRightTypeCanNotAll(cannot: any) {
  cannot("access", "Contact_Menu");
  cannot("access", "View_Contact");
  cannot("create", "Add_Contact");
  cannot("update", "File_Contact");
  cannot("create", "Edit_Contact");
  cannot("create", "Export_Contact");
  cannot("accessData", "Contact_Access_Data_All");
  cannot("accessData", "Contact_Access_Data_Customer");
  cannot("accessData", "Contact_Access_Data_Seller");
  cannot("update", "Delete_Contact");
  cannot("update", "Enable_Contact");

  cannot("access", "Edit_User_Role");
  cannot("access", "User_Setting_Menu");
  cannot("access", "PeakAccount");
  cannot("access", "OldPeak");
  cannot("access", "PeakAsset");
  cannot("access", "PeakBoard");
  cannot("access", "PeakPayroll");
  cannot("access", "PeakTax");

  cannot("access", "Advance_Setting");

  cannot("access", "View_SalesTaxInvoice");
  cannot("access", "View_PurchaseTaxInvoice");
  cannot("access", "View_PP30");
  cannot("create", "Create_SalesTaxInvoice");
  cannot("create", "Edit_SalesTaxInvoice");
  cannot("update", "Delete_SalesTaxInvoice");
  cannot("update", "Approve_SalesTaxInvoice");
  cannot("create", "Create_PurchaseTaxInvoice");
  cannot("create", "Edit_PurchaseTaxInvoice");
  cannot("update", "Delete_PurchaseTaxInvoice");
  cannot("update", "Approve_PurchaseTaxInvoice");

  cannot("create", "Create_PP30");
  cannot("create", "Edit_PP30");
  cannot("update", "Delete_PP30");
  cannot("update", "Approve_PP30");
  cannot("update", "Vat_Access_To_PeakData");
  cannot("access", "Vat_Report");
  cannot("update", "Vat_Payment");
  cannot("update", "Vat_TaxFiling");

  cannot("create", "Wht_Approve");
  cannot("create", "Wht_Create");
  cannot("create", "Wht_Delete");
  cannot("create", "Wht_Edit");
  cannot("create", "Wht_View");
  cannot("access", "WhtCertificate_Menu");
  cannot("access", "Wht_Menu");

  cannot("create", "Pnd1_Approve");
  cannot("create", "Pnd1_Create");
  cannot("create", "Pnd1_Delete");
  cannot("create", "Pnd1_Edit");
  cannot("create", "Pnd1_View");
  cannot("access", "Pnd1_Menu");

  cannot("create", "Pnd2_Approve");
  cannot("create", "Pnd2_Create");
  cannot("create", "Pnd2_Delete");
  cannot("create", "Pnd2_Edit");
  cannot("create", "Pnd2_View");
  cannot("access", "Pnd2_Menu");

  cannot("create", "Pnd3_Approve");
  cannot("create", "Pnd3_Create");
  cannot("create", "Pnd3_Delete");
  cannot("create", "Pnd3_Edit");
  cannot("create", "Pnd3_View");
  cannot("access", "Pnd3_Menu");

  cannot("create", "Pnd53_Approve");
  cannot("create", "Pnd53_Create");
  cannot("create", "Pnd53_Delete");
  cannot("create", "Pnd53_Edit");
  cannot("create", "Pnd53_View");
  cannot("access", "Pnd53_Menu");

  cannot("create", "Export_Wht");
  cannot("create", "Export_Pnd");
  cannot("accessData", "Pnd_Access_To_Peak");
  cannot("accessData", "Pnd_Payment_Access");
  cannot("accessData", "Pnd_Tax_Filing");
}

function DecompressApplicationPermission(compressedPermission: any) {
  const binaryData = Uint8Array.from(atob(compressedPermission), (byte) => byte.charCodeAt(0));
  const decompressedData = pako.inflateRaw(binaryData, { to: "string" });
  return JSON.parse(decompressedData);
}

export function DefineAbilityFor(user: any) {
  const { can, cannot, rules } = new AbilityBuilder();

  const userApplicationPermission = user.applicationPermission
    ? DecompressApplicationPermission(user.applicationPermission)
    : null;

  UserRightTypeCanNotAll(cannot);
  if (userApplicationPermission) {
    const { contact, setting, vat, wht } = userApplicationPermission;
    ManageContactV2(contact, can);
    ManageSettingV2(setting, can);
    ManageVatV2(vat, can);
    ManageApplicationV2(user.roleApplication, can);
    ManageWhtCertificateAndPndV2(wht, can);
  }

  return rules;
}
